import React, { useState } from "react";
import { createContainer } from "unstated-next";
import * as voicifyApi from '../api';
import { TelephonyDeploymentResponse } from "../models/telephonyDeployment/TelephonyDeploymentResponse";
import TelephonyDeploymentRequest from "../models/telephonyDeployment/TelephonyDeploymentRequest";
import { PHONE_PLATFORMS } from "../constants/phonePlatforms";
function useTelephonyDeploymentContainer() {
    const [telephonyDeployments, setTelephonyDeployments] = useState([] as TelephonyDeploymentResponse[]);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState([] as string[]);

    const getTelephonyDeployments = async (currentAppId: string) => {
        try {
            setIsLoading(true);
            const result = await voicifyApi.getTelephonyDeployments(currentAppId);
            if (result.resultType == "Ok") {
                setTelephonyDeployments(result.data);
            }
            else if (result.errors != null && result.errors.length > 0) {
                setErrors([...result.errors]);
                setTelephonyDeployments([]);
            }
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([error]);
            setIsLoading(false);
        }
    };

    const createTelephonyDeployment = async (currentAppId: string, request: TelephonyDeploymentRequest) => {
        try {
            setIsLoading(true);
            let result;
            if (request.platform === PHONE_PLATFORMS.VONAGE) {
                result = await voicifyApi.addTelephonyDeploymentVonage(currentAppId, request);
            }
            else if (request.platform === PHONE_PLATFORMS.TELNYX || !request.platform) {
                // Defaulting to Telnyx if no platform is specified as of 8/14/25
                result = await voicifyApi.addTelephonyDeploymentTelnyx(currentAppId, request);
            }
            if (result.errors != null && result.errors.length > 0) {
                setErrors([...result.errors]);
            }
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([error]);
            setIsLoading(false);
            return error;
        }
    };

    const updateTelephonyDeployment = async (currentAppId: string, phoneNumber: string, request: TelephonyDeploymentRequest) => {
        try {
            setIsLoading(true);
            const result = await voicifyApi.updateTelephonyDeployment(currentAppId, phoneNumber, request);
            if (result.errors != null && result.errors.length > 0) {
                setErrors([...result.errors]);
            }
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([error]);
            setIsLoading(false);
        }
    };

    const deleteTelephonyDeployment = async (currentAppId: string, phoneNumber: string) => {
        try {
            setIsLoading(true);
            const result = await voicifyApi.deleteTelephonyDeployment(currentAppId, phoneNumber);
            if (result.errors != null && result.errors.length > 0) {
                setErrors([...result.errors]);
            }
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([error]);
            setIsLoading(false);
        }
    };

    const moveTelephonyDeployment = async (currentAppId: string, phoneNumber: string, targetApplicationId: string) => {
        try {
            setIsLoading(true);
            const result = await voicifyApi.moveTelephonyDeployment(currentAppId, phoneNumber, targetApplicationId);
            if (result.errors != null && result.errors.length > 0) {
                setErrors([...result.errors]);
            }
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([error]);
            setIsLoading(false);
        }
    };

    return {
        isLoading,
        errors,
        clearErrors: () => setErrors([]),
        getTelephonyDeployments,
        telephonyDeployments,
        createTelephonyDeployment,
        updateTelephonyDeployment,
        deleteTelephonyDeployment,
        moveTelephonyDeployment,
    };
}

const TelephonyDeploymentContainer = createContainer(useTelephonyDeploymentContainer);
export default TelephonyDeploymentContainer;
